import { getVisitorScopesForOrg } from '../../app/constants/visitorScopes';

export const hasOnlyVisitorScopes = (
  tokenScopeItem?: Utils.ArrayElement<
    Api.Response['describeAccessToken']['tokenScopeList']
  >,
) => {
  if (!tokenScopeItem) return false;
  const { org, scope, user } = tokenScopeItem;
  const visitorScopes = getVisitorScopesForOrg(org?.id);

  const userScope = `user${user?.id}`;

  const filteredScopes = scope?.filter(
    (scopeItem) => !scopeItem.includes(userScope),
  );

  return (
    (filteredScopes?.length ?? 0) > 0 &&
    filteredScopes?.every((scopeItem) => visitorScopes.includes(scopeItem))
  );
};
